import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const jiraTemplate = {
	id: 'jira',
	guid: '43209c98-b060-41bf-8cf6-545a6afccf77',
	name: 'Jira',
	category: TEMPLATE_CATEGORIES.PRODUCTIVITY,
	popularity: 'Popular',
	color: '#0052cc',
	icon: 'mdi-jira',
	description: 'Create Jira Cloud issues when privacy requests or tasks approach or breach their statutory deadlines.',
	features: ['Issue Tracking', 'Deadline Escalation', 'Labels', 'Project Routing'],
	endpoints: [
		{
			name: 'Create Issue - Request/Task Nearing Deadline',
			url: 'https://[your-domain].atlassian.net/rest/api/2/issue',
			method: 'POST',
			description: 'Create a Jira issue when a privacy request or task enters its warning window. Replace [your-domain], [PROJECT_KEY] and the issue type with your own values.',
			cassieObjectID: -16,
			incrementField: 'ID',
			resetIncrementValue: false,
			fields: [
				{ name: 'EventTitle', filter: '' },
				{ name: 'RequestNumber', filter: '' },
				{ name: 'Reference', filter: '' },
				{ name: 'Deadline', filter: '' },
				{ name: 'DaysUntilDue', filter: '' }
			],
			requestBody: '{ "fields": { "project": { "key": "[PROJECT_KEY]" }, "issuetype": { "name": "Task" }, "summary": "[PLACEHOLDER_EVENTTITLE] - Request [PLACEHOLDER_REQUESTNUMBER]", "description": "[PLACEHOLDER_EVENTTITLE] for privacy request [PLACEHOLDER_REQUESTNUMBER] (reference [PLACEHOLDER_REFERENCE]). Deadline [PLACEHOLDER_DEADLINE]; days until due: [PLACEHOLDER_DAYSUNTILDUE].", "labels": ["privacy-nearing-deadline"] } }',
			headers: [
				{ Name: 'Authorization', value: 'Basic [BASE64_EMAIL_APITOKEN]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 201, message: '' }]
		},
		{
			name: 'Create Issue - Deadline Breached',
			url: 'https://[your-domain].atlassian.net/rest/api/2/issue',
			method: 'POST',
			description: 'Create a Jira issue when a privacy request or task passes its statutory deadline while still open. Replace [your-domain], [PROJECT_KEY] and the issue type with your own values.',
			cassieObjectID: -17,
			incrementField: 'ID',
			resetIncrementValue: false,
			fields: [
				{ name: 'EventTitle', filter: '' },
				{ name: 'RequestNumber', filter: '' },
				{ name: 'Reference', filter: '' },
				{ name: 'Deadline', filter: '' },
				{ name: 'DaysOverdue', filter: '' }
			],
			requestBody: '{ "fields": { "project": { "key": "[PROJECT_KEY]" }, "issuetype": { "name": "Task" }, "summary": "[PLACEHOLDER_EVENTTITLE] - Request [PLACEHOLDER_REQUESTNUMBER]", "description": "[PLACEHOLDER_EVENTTITLE] for privacy request [PLACEHOLDER_REQUESTNUMBER] (reference [PLACEHOLDER_REFERENCE]). Deadline was [PLACEHOLDER_DEADLINE]; days overdue: [PLACEHOLDER_DAYSOVERDUE].", "labels": ["privacy-deadline-breached"] } }',
			headers: [
				{ Name: 'Authorization', value: 'Basic [BASE64_EMAIL_APITOKEN]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 201, message: '' }]
		}
	],
	defaults: {
		endpointAddress: 'https://[your-domain].atlassian.net',
		authenticationTypeId: AUTH_TYPES.NO_AUTH,
		// Per-service throttle (ms) between outbound calls, distinct from the system poll cadence.
		// Jira Cloud rate-limits per minute and the connector's retries are bounded, so ship a
		// non-zero throttle by default; the first sweep after deploy may burst a breach backlog.
		requestThrottlingWaitTimeMS: 1000,
		notes: 'Jira Cloud issues for privacy deadline escalation, via the v2 REST API (v3 needs Atlassian Document Format, unsuited to token templating). No runtime auth is attached: replace [BASE64_EMAIL_APITOKEN] in the Authorization header with base64(your-email:api-token) and treat it as a revocable credential. Jira rate-limits per minute and connector retries are bounded, so keep a non-zero request throttle; the first sweep after deploy may burst a backlog of breached requests.'
	}
}
